"use client";

import { useCountry } from "@leabankab/component-library";
import { type CountryCode, toCountryCode } from "@/config/country-config";
import {
	COUNTRY_SETTINGS,
	type CountrySettings,
} from "@/config/country-settings";

/** The library's active country, narrowed to SE | FI | NO. */
export const useAppCountry = (): CountryCode =>
	toCountryCode(useCountry().country);

export const useCountrySettings = (): CountrySettings =>
	COUNTRY_SETTINGS[useAppCountry()];
